import ApiService from "../ApiService";

const deliveryPointService = {
    create(deliveryPoint, location) {
        const data = {
            deliveryPoint,
            location
        }
        return ApiService.post(`/delivery-point`, data);
    },
    getAll() {
        return ApiService.get(
            `/delivery-point/`
        );
    },
    getByCity(city) {
        return ApiService.get(
          `/delivery-point/getByCity?city=${city}`
        );
    },
    getByCities(data) {
        return ApiService.post(
          `/delivery-point/getByCities`,
          data
        );
    },
    getDeliveryPoints(page, rowsPerPage, search) {
        return ApiService.get(
          `/delivery-point/search?page=${page}&perPage=${rowsPerPage}&searchString=${search}`
        );
    },
    update(id, deliveryPoint, location) {
        const data = {
            deliveryPoint,
            location
        }
        return ApiService.post(`/delivery-point/update?id=${id}`, data);
    },
    delete(data) {
        return ApiService.post(`/delivery-point/remove`, data);
    },
    validateDelete(data) {
        return ApiService.post(`/delivery-point/validateDelete`, data);
    }
};

export default deliveryPointService
